module.exports = __webpack_public_path__ + "img/menu1-1.4d5ea9fd.jpg";